import { useSlots as _useSlots, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ea967c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "type"]
const _hoisted_2 = { key: 1 }

import { GenericButtonVariantEnum } from "@/types/button";
import { IconType } from "@/types/icons";
import { Comment, computed, Fragment, defineSlots } from "vue";
import { useI18n } from "vue-i18n";
import Icon from "@/components/icons/Icon/Icon.vue";
import { convertAsArray } from "@/utils/modifiers";

interface Props {
  variant?: GenericButtonVariantEnum;
  text?: string;
  onClick?: () => void;
  disableTranslation?: boolean;
  id?: string;
  isLoading?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GenericButton',
  props: {
    variant: { default: GenericButtonVariantEnum.Primary },
    text: { default: "" },
    onClick: { type: Function, default: undefined },
    disableTranslation: { type: Boolean, default: false },
    id: { default: undefined },
    isLoading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const slots = _useSlots();
const { t } = useI18n();

const props = __props;

const isVisible = computed(() => {
  const vnode = slots.default?.();
  const isEmpty =
    !vnode ||
    convertAsArray(vnode).every(
      (vnode) =>
        vnode.type === Comment ||
        (vnode.type === Text && !vnode.children?.length) ||
        (vnode.type === Fragment && !vnode.children?.length),
    );
  return !isEmpty;
});

const appliedText = computed<string>(() => {
  return props.disableTranslation ? props.text : t(props.text);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    id: _ctx.id,
    class: _normalizeClass(["generic-button", { [_ctx.variant]: true, 'hidden-content': _ctx.isLoading }]),
    type: _ctx.onClick ? 'button' : 'submit',
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    (isVisible.value)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 })
      : _createCommentVNode("", true),
    (_ctx.text)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(appliedText.value), 1))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(Icon, {
          key: 2,
          icon: _unref(IconType).SPINNER,
          class: "loading-spinner"
        }, null, 8, ["icon"]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})